import { encodeDocumentType, decodeDocumentType } from './documentType';
import { encodePageNumber, decodePageNumber } from './page';
import { encodeSortBy, decodeSortBy } from './sortBy';

export * from './documentType';
export * from './page';
export * from './sortBy';

export const encoders = {
  encodeDocumentType,
  encodePageNumber,
  encodeSortBy,
};

export const decoders = {
  decodeDocumentType,
  decodePageNumber,
  decodeSortBy,
};
